import { useRowsAdditionalData } from "PFApp/booking/store/provider/additional_data";
import { useCalendarRootRows } from "PFApp/booking/store/provider/calendar_root_rows";
import { useResetters } from "PFApp/booking/store/provider/resetters";
import { useRowsColumns } from "PFApp/booking/store/provider/use_rows_columns";
import { useThresholds } from "PFApp/booking/store/provider/use_thresholds";
import { PropsWithChildren } from "react";

const AdditionalDataProvider = () => {
  // extracted to not trigger useCalendarRootRows rerender when vertical range changes
  useRowsAdditionalData();
  return null;
};

export const BookingModuleDataController = ({ children }: PropsWithChildren) => {
  useCalendarRootRows();
  useRowsColumns();
  useThresholds();
  useResetters();

  return (
    <>
      <AdditionalDataProvider />
      {children}
    </>
  );
};
